export const REACT_APP_API_URL = '/backend/pcoService';
export const PRODUCTS_AND_SERVICES = 'products-and-services';
export const APP_CONFIG_URL = '/app-config';
